import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const NewContentBlock = lazy(() =>
  import("@scenes/MessageComposition/ContentBlocks/NewContentBlock").then((module) => ({
    default: module.NewContentBlock,
  }))
);

export const newContentBlockNRO: NavigationRoutingObject = {
  componentFeatureFlippers: [],
  Component: NewContentBlock,
  noKnockoutFallback: true,
  section: "templates",
  heading: (t: I18nT<"dashboard-navigation">) => t("new-content-block-heading", "New Content Block"),
  pageNameForTracking: () => "New Content Block",
  icon: "nav-system-content-blocks",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/templates_and_media/content_blocks/:appGroupId/new",
};
